export const isEnvDev = process.env.NODE_ENV === 'development';
export const isEnvProd = process.env.NODE_ENV === 'production';
export const isVercelProd = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';
export const isEnvSSR = typeof window === 'undefined';
export const isVercel = process.env.VERCEL === '1';
export const isSyncBackend = process.env.SYNC_BACKEND === 'true';
